module.exports = __webpack_public_path__ + "img/side-icon-32.58dc54f8.svg";